// Ticket confirmations use page UI, never blocking browser dialogs (WebViews
// may suppress those). Keep hx-confirm as a fail-closed fallback if JS fails.
(() => {
  if (window.ticketConfirm) return;
  let active = null;
  function showDialog(message, source, templateId) {
    if (active) return Promise.resolve(false);
    const template = document.getElementById(templateId);
    if (!template) return Promise.resolve(false);
    const overlay = template.content.firstElementChild.cloneNode(true);
    const panel = overlay.querySelector('[role="alertdialog"]');
    const cancel = overlay.querySelector('[data-dialog-cancel]');
    const accept = overlay.querySelector('[data-dialog-accept]');
    const initialFocus = cancel || accept;
    overlay.querySelector('[data-dialog-message]').textContent = message;
    // Stay inside CoreUI's current focus trap rather than opening a second
    // framework modal on top of the seat selector/offcanvas.
    const host = source?.closest?.('.modal.show, .offcanvas.show') || document.body;
    host.appendChild(overlay);
    window.ticketDialogOpen = true;
    return new Promise(resolve => {
      const finish = (accepted) => {
        if (!active) return;
        active = null;
        window.ticketDialogOpen = false;
        document.removeEventListener('keydown', onKey, true);
        document.removeEventListener('focusin', onFocus, true);
        overlay.remove();
        if (source?.isConnected) source.focus?.();
        resolve(accepted);
      };
      const onFocus = event => {
        if (!panel.contains(event.target)) initialFocus.focus();
      };
      const onKey = event => {
        if (event.key === 'Escape') {
          event.preventDefault(); event.stopImmediatePropagation(); finish(false);
        } else if (event.key === 'Tab') {
          event.preventDefault(); event.stopImmediatePropagation();
          (cancel && document.activeElement === accept ? cancel : accept).focus();
        }
      };
      active = {finish};
      cancel?.addEventListener('click', () => finish(false));
      accept.addEventListener('click', () => finish(true));
      overlay.addEventListener('click', event => {if (event.target === overlay) finish(false);});
      document.addEventListener('keydown', onKey, true);
      document.addEventListener('focusin', onFocus, true);
      initialFocus.focus();
    });
  }
  window.ticketConfirm = function (message, source = document.activeElement) {
    return showDialog(message, source, 'ticket-confirm-template');
  };
  window.ticketPurchaseLimit = function (message, source = document.activeElement, code = 'invite_purchase_limit_reached') {
    return showDialog(message, source, code === 'seat_order_limit_reached' ? 'ticket-order-limit-template' : 'ticket-purchase-limit-template');
  };
  window.addEventListener('pagehide', () => active?.finish(false));
  document.addEventListener('htmx:confirm', event => {
    const {elt, question, issueRequest} = event.detail;
    if (!question || !elt.closest('[data-ticket-confirm]')) return;
    event.preventDefault();
    window.ticketConfirm(question, elt).then(accepted => {
      if (accepted && elt.isConnected) issueRequest(true);
    });
  });
})();
